import { NgStyle, UpperCasePipe } from '@angular/common';
import { AfterViewInit, Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import { MatButtonModule } from '@angular/material/button';
import { EcaGenericMessageDialogComponent, EcaGenericMessageDialogConfig } from '@drc-eca/eca-components-lib';
import { ClientStatusService } from '../../status/client-status.service';
import { ConfirmDialogComponent } from '../../../confirm-dialog/confirm-dialog.component';
import { IStatusType } from '../../../model/common.model';
import { AddUpdateStatusTypeModalComponent } from '../add-update-status-type-modal/add-update-status-type-modal.component';


@Component({
    selector: 'app-update-status-types',
    standalone: true,
    templateUrl: './update-status-types.component.html',
    styleUrls: ['./update-status-types.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [MatTableModule, MatButtonModule, UpperCasePipe, NgStyle]
})
export class UpdateStatusTypesComponent implements OnInit, AfterViewInit {
  private clientStatusSvc = inject(ClientStatusService);
  dialog = inject(MatDialog);

  inprogress = false;
  statusType: IStatusType;
  statusTypes: IStatusType[] = [];
  selecteStatusType: IStatusType;
  dataSource: MatTableDataSource<any> = new MatTableDataSource<any>([]);
  displayedColumns: string[] = ['statusName', 'statusPrecedence','statusMessage','showServiceList', 'statusColorCode', 'action'];
  dialogRef: MatDialogRef<ConfirmDialogComponent>;
  
  @ViewChild(MatSort) sort: MatSort;

  ngOnInit(): void {
    this.getStatusList();
  }

  getStatusList(){
    this.inprogress = true;
    this.clientStatusSvc.getServiceStatusList().subscribe({next: (statuses)=>{
      this.statusTypes = statuses  || [];
      this.dataSource.data = this.statusTypes;
      this.inprogress = false;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    }, error: (error)=>{
      this.inprogress = false;
    }})
  }

  openAddUpdateStatusTypeModal(selecteStatusType: IStatusType = null){
    const serviceDialogRef = this.dialog.open(AddUpdateStatusTypeModalComponent, {
      width: '550px',
      data:{
        selectedStatusType: selecteStatusType,
        statusTypes: this.statusTypes
      }
    });

    serviceDialogRef.afterClosed().subscribe((result: {cancel: boolean, form: UntypedFormGroup}) => {
      let action = 'Add';
      if(!result.cancel){
        const payload: IStatusType = result.form.getRawValue();
        if(result.form.controls.statusColorCodeOther.value && result.form.controls.statusColorCode.value == 'Other'){
          payload.statusColorCode = result.form.controls.statusColorCodeOther.value;
        }
        delete payload['statusColorCodeOther'];
        if(selecteStatusType){
          payload.primaryKeyPart = selecteStatusType.primaryKeyPart;
          payload.secondaryKeyPart = selecteStatusType.secondaryKeyPart;
          action = 'Update';
        }
        
        this.addStatusType(payload, action);
      }
    });
  }

  addStatusType(payload: any, action: string) {
    this.inprogress = true;    
    this.clientStatusSvc.doPost(`admin/status`, payload).subscribe(() => {
      this.clientStatusSvc.showSuccess(`Status ${payload.statusName} ${action}ed successfully.`);
      this.inprogress = false;
      this.getStatusList();
    }, () => {
      this.inprogress = false;
      this.clientStatusSvc.showWarning(`Failed to ${action} Status ${payload.statusName}.`);
    });
  }

  openConfirmationDialog(statusType: IStatusType){
    const dialogConfig: MatDialogConfig<EcaGenericMessageDialogConfig> = {
      data: {
        title: `Delete Status  ${statusType.statusName}`,
        message: `Are you sure you want to delete "${statusType.statusName}" status?`,
        buttons: {
          negative: { label: 'Cancel' },
          positive: { label: 'Delete' }
        }
      },
      maxWidth: '650px'
    };

    const dialogRef = this.dialog.open(EcaGenericMessageDialogComponent, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.deleteStatusType(statusType);
      }
    });
  }

  deleteStatusType(statusType: IStatusType) {
    this.inprogress = true;
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    this.clientStatusSvc.doDelete('admin/status', statusType.secondaryKeyPart.split("#").pop()).subscribe(data => {
      this.clientStatusSvc.showSuccess(`Status ${statusType.statusName} deleted successfully.`);
      this.inprogress = false;
      this.getStatusList();
    }, () => {
      this.inprogress = false;
      this.clientStatusSvc.showWarning(`Failed to Delete Status Type ${statusType.statusName}.`);
    });
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }
}
